<form [formGroup]="serviceCategoryForm!" class="w-full sm:w-[55vh]">

  <!--            NAME-->
  <div class="flex flex-col gap-1">
    <mat-label>{{"service-category-name" | translate}}</mat-label>
    <mat-form-field appearance="outline" floatLabel="never">
      <mat-icon matPrefix><i class="fa-regular fa-box-archive text-[2rem] pr-[1rem]"></i></mat-icon>
      <input matInput pattern="[a-zA-Zа-яА-ЯѓЃќЌјЈџЏѕЅжЖљЈчЧњЌЌѝЍ() ]*" type="text"
              [formControlName]="'name'" minlength="3"
              placeholder='{{"Name of service" | translate}}'>
      <mat-error *ngIf="serviceCategoryForm.get('name')! && serviceCategoryForm.get('name')?.errors">
        <span *ngIf="serviceCategoryForm.get('name')?.hasError('required')!">{{"Required Field" | translate}}</span>
        <span *ngIf="serviceCategoryForm.get('name')?.hasError('minlength')!">{{"Required minimum 3 caracters" | translate}}</span>
        <span *ngIf="serviceCategoryForm.get('name')?.hasError('pattern')!">{{"Allowed only letters" | translate}}</span>
      </mat-error>
    </mat-form-field>
  </div>

  <!--            SERVICE TYPE-->
  <div class="flex flex-col gap-1">
    <mat-label>{{"service-category-type" | translate}}</mat-label>
    <mat-form-field appearance="outline" floatLabel="never">
      <mat-icon matPrefix> <i class="fa-regular fa-list text-[2rem] pr-[1rem]"></i> </mat-icon>
      <mat-select [formControlName]="'serviceTypeId'" placeholder='{{"type" | translate}}' required>
        <mat-option [value]="0" disabled>{{"selectCategoryType" | translate }}</mat-option>
        <mat-option *ngFor="let serviceType of serviceTypes" [hidden]="true"
                    [value]="serviceType.id"> {{ serviceType.name }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="serviceCategoryForm.get('serviceTypeId')! && serviceCategoryForm.get('serviceTypeId')?.errors">
        <span *ngIf="serviceCategoryForm.get('serviceTypeId')?.hasError('required')">{{"Required Field" |translate}}</span>
      </mat-error>
      <mat-error>
        <span *ngIf="serviceCategoryForm.get('serviceTypeId')?.hasError('min')">{{"Required Field" |translate}}</span>
      </mat-error>
    </mat-form-field>
  </div>

  <!--            MEMBERSHIP-->
  <div class="flex flex-col gap-1">
    <mat-label>{{"service-category-requires-membership" | translate}}</mat-label>
    <mat-form-field appearance="outline" floatLabel="never">
      <mat-icon matPrefix><i class="fa-sharp fa-regular fa-address-card text-[2rem] pr-[1rem]"></i></mat-icon>
      <mat-select [formControlName]="'requiresMembership'"
                  placeholder='{{"Yes" | translate}}' required>
        <mat-option [value]="1">{{'Yes' | translate}}</mat-option>
        <mat-option [value]="0">{{'No' | translate}}</mat-option>
      </mat-select>
      <mat-error *ngIf="serviceCategoryForm.get('requiresMembership')! && serviceCategoryForm.get('requiresMembership')?.errors">
        <span *ngIf="serviceCategoryForm.get('requiresMembership')?.hasError('required')">{{"Required Field" |translate}}</span>
      </mat-error>
    </mat-form-field>
  </div>

  <!--            IMAGE-->
  <div class="flex flex-row gap-2 sm:gap-5 justify-between items-center sm:items-center mobile-display w-full py-3 border border-r-transparent border-l-transparent border-top-[#2C99B1] border-bottom-[#2C99B1]">
    <input type="file" style="display: none" accept="image/png, image/jpeg" (change)="onFileSelected($event)" #fileUpload />
    <div class="flex flex-col justify-start gap-1 w-max">
      <div> {{"photography" | translate}}: </div>
      <div *ngIf="imageName != ''" class="text-[#1A3854]">
        {{imageName | truncate: (windowDimensions.width >= windowDimensions.threshold_sm ? 25 : 10)}}
      </div>
    </div>

    <div class="flex flex-row justify-center py-2 px-2 sm:px-5 rounded-lg shadow-md bg-[#257C95] text-white uppercase hover:cursor-pointer bg-[##192D4A] text-base sm:text-xl"
      (click)="fileUpload.click()">{{this.serviceCategoryId == undefined ? ('Attach photo' | translate ) : ('Edit photo' | translate )}}
    </div>
  </div>

  <!--            ACTIVE-->
  <div class="flex flex-row gap-5 justify-between items-center w-full py-2 border border-r-transparent border-l-transparent border-t-transparent border-bottom-[#2C99B1]">
    <div>{{'status' | translate}}:</div>

    <mat-checkbox class="-mb-1"
                  [formControlName]="'active'"
                  class="font-semibold">{{'service-category-active' | translate}}
    </mat-checkbox>

  </div>

  <!--        ERROR-->
  <div *ngIf="showError"
       class="w-full py-3 px-5 flex flex-row gap-3 bg-[#F5D3D3] text-[#D94E4E] rounded-lg items-center mt-12">
    <i class="fa-sharp fa-regular fa-triangle-exclamation text-3xl"></i>
    <div>{{"category exist" | translate }}"{{serviceCategoryForm.get('name')?.value}}"</div>
  </div>

  <!--        ACTION BUTTONS-->
  <div class="flex flex-row gap-10 text-[1rem] sm:text-[1.35rem]" [ngClass]="{'mt-[1rem]': showError, 'mt-[2rem]': !showError}">
    <button (click)="closePopup()" type="button"
      class="w-1/2 px-5 py-[.5rem] rounded-[.25rem] uppercase bg-[#dadada] text-[#696767] hover:bg-[#c4c4c4] shadow-md active:scale-[0.985] active:shadow-sm">
      {{"back" | translate}}
    </button>

    <button [disabled]="serviceCategoryForm.invalid" [ngClass]="{
          'bg-[#b98d78] hover:bg-[#a57d6a] active:scale-[0.985] active:shadow-sm': serviceCategoryForm.valid,
          'bg-[#b98d78]/20 hover:bg-[#a57d6a]/20': serviceCategoryForm.invalid
        }" (click)="submit()" class="w-1/2 px-5 py-[.5rem] uppercase rounded-[.25rem] text-white shadow-md ">
      {{"save" | translate}}
    </button>
  </div>

</form>
